import React from 'react';
import { Spinner } from 'react-bootstrap';

interface LoadingProps {
  text?: string;
  fullScreen?: boolean;
}

export const Loading: React.FC<LoadingProps> = ({
  text = '로딩 중...',
  fullScreen = false,
}) => {
  if (fullScreen) {
    return (
      <div
        className="d-flex flex-column align-items-center justify-content-center"
        style={{ minHeight: '100vh' }}
      >
        <Spinner animation="border" variant="primary" />
        <p className="mt-3 text-secondary">{text}</p>
      </div>
    );
  }

  return (
    <div className="loading-container">
      <Spinner animation="border" variant="primary" />
      <p className="loading-text">{text}</p>
    </div>
  );
};

export const SkeletonCard: React.FC = () => {
  return <div className="skeleton skeleton-card" />;
};

export const SkeletonList: React.FC<{ count?: number }> = ({ count = 5 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <SkeletonCard key={index} />
      ))}
    </>
  );
};
